import { updateUser, isInitializated } from '@commons/fwf/instance';

function updateFwfCity({ cityFullName, cityId }) {
  if (isInitializated()) {
    try {
      const contextData = {
        city: cityFullName,
        cityId: cityId || '',
      };
      updateUser({ contextData });
    } catch (error) {
      const updatedError = new Error('[updateFwfCity] fails to updateUser');
      if (error.stack) updatedError.stack = error.stack;
      throw updatedError;
    }
  }
}

export default updateFwfCity;
